import React from 'react';
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/fontawesome.css';
import '../assets/css/root.css';

import serviceIcon01 from '../assets/images/service-icon-01.png';
import serviceIcon02 from '../assets/images/service-icon-02.png';
import serviceIcon03 from '../assets/images/service-icon-03.png';

import { constants } from './Constant';
import $ from 'jquery'; 
window.jQuery = window.$ = $; 

const Services = () => {
  const options = {
    items: 3,
    loop: true,
    nav: true,
    navText: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 2000,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
  }
  
  };

  const DESCRIPTION_CHAR_LIMIT = 120;
  const shortDescription = (descriptionMsg) => {
    return descriptionMsg.substring(0, DESCRIPTION_CHAR_LIMIT) + '...';
  };

  const servicesData = [
   { icon: serviceIcon01, title: constants?.servicesCard?.card1Title, description: constants?.servicesCard?.card1Description },
    { icon: serviceIcon02, title: constants?.servicesCard?.card2Title, description: constants?.servicesCard?.card2Description },
    { icon: serviceIcon03, title: constants?.servicesCard?.card3Title, description: constants?.servicesCard?.card3Description },
    { icon: serviceIcon02, title: constants?.servicesCard?.card4Title, description: constants?.servicesCard?.card4Description },
    { icon: serviceIcon03, title: constants?.servicesCard?.card5Title, description: constants?.servicesCard?.card5Description },
  ];

  return (
    <section className="services">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <OwlCarousel options={options}>
              {servicesData.map((service, index) => (
                <div key={index} className="item">
                  {console.log(index,'lav',service)}
                  <div className="icon">
                    <img src={service.icon} alt={service.title} />
                  </div>
                  <div className="down-content">
                    <h4>{service.title}</h4>
                    <p>{shortDescription(service.description)}</p>
                  </div>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
